/**
 * AudioEqualizer — CSS-only 3-bar animation for voice playback feedback.
 *
 * Shown in message bubble when audio is actively playing.
 */

import React from 'react';

const AudioEqualizer: React.FC = () => (
  <div className="inline-flex items-end gap-0.5 h-3.5 ml-1.5 align-middle">
    <div
      className="w-0.5 bg-teal-400 rounded-full"
      style={{
        animation: 'eqBar 0.8s ease-in-out infinite alternate',
        height: '40%',
      }}
    />
    <div
      className="w-0.5 bg-teal-400 rounded-full"
      style={{
        animation: 'eqBar 0.8s ease-in-out infinite alternate',
        animationDelay: '0.2s',
        height: '70%',
      }}
    />
    <div
      className="w-0.5 bg-teal-400 rounded-full"
      style={{
        animation: 'eqBar 0.8s ease-in-out infinite alternate',
        animationDelay: '0.4s',
        height: '50%',
      }}
    />
    <style>{`
      @keyframes eqBar {
        0% { height: 20%; }
        100% { height: 100%; }
      }
    `}</style>
  </div>
);

export default AudioEqualizer;
